/* eslint-disable max-len */
import React, { useContext   } from 'react'
import { useEffect,useCallback,useState } from 'react'
import { dataService } from '../../../services/data.services'
import GlobalContext from '../../Context/GloablContext';
import Loader from '../../Loader';
import { useSelector } from 'react-redux';
import { CheckUserStatus } from '../../../CommonMethods/CheckUserStatus';

const moment = require('moment');

export default function SignoutModal(adminOptions) {
    const {userType,clock_in_out_facitilty}=useSelector(state=>state.auth)
    const [loading, setloading] = useState(false);
    const [id, setid] = useState('')
    const {setToastmessage,Toastmessage,setToastErrorMessage}=useContext(GlobalContext)
    const currentDate = moment();
    const [clockStatus, setclockStatus] = useState('');
    const [record, setrecord] = useState({})
    const handlefetch=useCallback(
        async() => {
            const res = await dataService.GetAPI('attendance', true);
            if(res.data.status===200){
                if(res.data.data?.record){
                    setrecord(res.data.data?.record);
                    setclockStatus(res.data.data?.record.action)

                }

            }
        },
        [adminOptions],
    )
    useEffect(() => {
        if(adminOptions && userType !== 'institution-user' && userType !=='institution-admin'){
            handlefetch()

        }
    }, [handlefetch]);
    const payloadMaker = ()=>{
        let payload={
            "action": "clock-in",

        };
        if(clockStatus==='clock-in'){
            payload={}
            payload= {
                "action": "clock-out",
                "id": record._id    
            }
        }
        return payload
    }
    const handleClockInOut=async()=>{
        setloading(true)
        // CheckUserStatus()
        const payload=payloadMaker()
        try {
            const res = await dataService.PostAPI(payload,'attendance');
            if(res.data.status ===200 || res.data.status===201){
                setloading(false);
                setToastmessage(res.data.data.message)


            }
        } catch (error) {
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            
        }
    }
    
    return (
        <>{(userType !== 'institution-user' && userType !=='institution-admin') && clock_in_out_facitilty &&
        <li className=''>
            <div class="w-full border-b border-[#c2dcef] rounded-t-lg ">
                <div class="flex items-center bg-[#EEF7FE] p-2 rounded">
                    <img loading="lazy" decoding="async" src="/images/clock.svg" alt="img" />
                    <p class="pl-2">Clock In/Clock Out</p>
                </div>
                <div style={{ 'margin': '6px 8px' }}>
                    <div class="flex justify-between border border-[#C2DCEF] p-2 rounded mt-2">
                        <div>
                            <p class="text-xs leading-[8px] font-normal text-[#031624] mb-1">{currentDate.format('dddd')}</p>
                            <p class="text-xs leading-[8px] font-normal text-[#031624] pt-1.5">{currentDate.format('MMM DD,YYYY')}</p>                            </div>
                        <p class="text-xs text-[#031624]">{currentDate.format('h:mm A')}</p>
                    </div>
                    <button disabled={clockStatus === 'clock-out' || Toastmessage !== ''} onClick={() => handleClockInOut()} type="button" class={`mt-2 mb-2 py-1.5  ${clockStatus !== 'clock-out' ? 'bg-[#106EB4] ' : 'bg-[#818E98] pointer-none'} w-full text-sm ltr-spcng-8 text-[#FFFFFF] rounded`}
                        id="clock_in_btn">
                        {console.log(clockStatus ,"ddddddddddddddddd")}
                        <>{loading ? <Loader /> : <>{clockStatus === '' ? 'Clock In' : 'Clock Out'}</>}</>
                    </button>
                
                    {/* <!-- disabled button bg-[#818E98] --> */}
                    {clockStatus === '' && <p class="text-xs leading-[12px] font-normal text-[#031624] not_clocked_in text-center">Not clocked in yet</p>}                        {clockStatus === 'clock-in' && <div class="flex items-center hidden clocked_in">
                        <img src="/images/success_tick.png" alt="img" loading="lazy" class="w-[12px] h-[12px] absolute" />
                        <span class="text-xs leading-[12px] font-normal text-[#031624] pl-4 text-center">Clocked in at {moment(record.clock_in_time).format('h:mm A')}</span>                    </div>}
                    {clockStatus === 'clock-out' && <div class="flex items-center hidden clocked_out_time">
                        <img src="/images/success_tick.png" alt="img" loading="lazy" class="w-[12px] h-[12px] absolute" />
                        <span class="text-xs leading-[12px] font-normal text-[#031624] pl-4 text-center">Clocked out at {moment(record.clock_out_time).format('h:mm A')}</span>
                    </div>}          
                </div>
            </div>
        </li>}</>
    )
}
